module.exports = __webpack_public_path__ + "img/how-works-modal-image-03.0090a0c.svg";